import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58d35654&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d35654",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WAudioListNuevo from '@/components/WAudioListNuevo.vue'
import WLoading from '@/components/WLoading.vue'
import WRecordAudio from '@/components/WRecordAudio.vue'
import WSwitch from '@/components/WSwitch.vue'
import WTopBar from '@/components/WTopBar.vue'
autoInstallComponents(component, {WAudioListNuevo,WLoading,WRecordAudio,WSwitch,WTopBar})
